import { Trans } from '@lingui/react'
import { string } from 'prop-types'

import IconArrowRight from 'views/components/atoms/Icon/IconArrowRight'

const ProductVariantCompactFollowUpLink = ({ followUpProductCode }) =>
  followUpProductCode ? (
    <a href={followUpProductCode} className="a-h6 u-no-margin">
      <Trans id="productVariants.link.toSuccessor" />
      <IconArrowRight />
    </a>
  ) : null

ProductVariantCompactFollowUpLink.propTypes = {
  followUpProductCode: string,
}

ProductVariantCompactFollowUpLink.defaultProps = {
  followUpProductCode: null,
}

export default ProductVariantCompactFollowUpLink
